class LineChart extends React.Component {
  componentDidMount() {
    this.updateChart(this.props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.updateChart(nextProps);
    return false;
  }

  updateChart(props) {
    let svg = d3.select(ReactDOM.findDOMNode(this));

    let x = d3.scaleLinear()
      .domain([0, props.data.length - 1])
      .range([5, props.width - 5]);

    let y = d3.scaleLinear()
      .domain(props.domain)
      .range([props.height - 3, 3]);

    let interpolators = {
      line: d3.curveLinear,
      step: d3.curveStep,
      smooth: d3.curveMonotoneX
    };

    let interpolator = interpolators[props.shape];

    let line = d3.line()
      .curve(interpolator)
      .x(function (d, i) {
        return x(d.x);
      })
      .y(function (d, i) {
        return y(d.y);
      });

    let area = d3.area()
      .curve(interpolator)
      .x(function (d, i) {
        return x(d.x);
      })
      .y0(props.height)
      .y1(function (d, i) {
        return y(d.y);
      });

    let lineData = props.data.map(function (y, i) {
      return { x: i, y: y };
    });

    let stroke = svg.selectAll(".line-stroke");

    stroke.attr("d", line(lineData));

    if (this.props.fill) {
      let fill = svg.selectAll(".line-fill");

      fill.attr("d", area(lineData));
    }

    let circles = svg.selectAll("circle").data(lineData);

    circles = circles
      .enter()
      .append("circle")
      .merge(circles)
      .attr("fill", props.color)
      .attr("r", 3);

    circles
      .exit()
      .remove();

    circles
      .attr("cx", function (d, i) {
        return x(d.x);
      })
      .attr("cy", function (d, i) {
        return y(d.y);
      });
  }

  render() {
    let { width, height, color, margin = "0 1em 1em 0" } = this.props;

    return (
      <svg className="mc-chart" width={width} height={height} style={{ margin }}>
        <path
          className="line-fill"
          fill={color}
          opacity="0.2"
          style={{ pointerEvents: "none" }}/>
        <path
          className="line-stroke"
          fill="none"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"/>
      </svg>
    );
  }
}

LineChart.defaultProps = {
  color: "#666666", // required
  data: [], // required
  width: 100,
  height: 25,
  shape: "line", // line | smooth | step
  fill: false,
  domain: [0, 1]
};

module.exports = LineChart;
